import apiCall from "../../utils/api";
import {DOMAINS_CLEAR, DOMAINS_ERROR, DOMAINS_REQUEST, DOMAINS_SELECT, DOMAINS_SUCCESS} from "../actions/domains";
import Vue from 'vue'

const state = {
    status: '',
    selectedDomain: null,
    domains: []
};

const actions = {
    // Запрос получения информации о доменах пользователя
    [DOMAINS_REQUEST]: ({commit, dispatch}) => {
        commit(DOMAINS_REQUEST);
        apiCall({url: 'domain/index', 'method': 'get'})
            .then(resp => {
                commit(DOMAINS_SUCCESS, resp);
                dispatch(DOMAINS_SELECT);

            })
            .catch(error => {
                console.log('Error', error);
                commit(DOMAINS_ERROR);
            });
    },
    [DOMAINS_SELECT]: ({commit}) => {
        let selectedDomain = null;

        let selectedDomainId = +localStorage.getItem('selected-domain-id');
        if (selectedDomainId) {
            state.domains.forEach(function (domain) {
                if (domain.id === selectedDomainId) {
                    selectedDomain = domain;

                }
            });
        }
        if (!selectedDomain && state.domains.length > 0) {
            selectedDomain = state.domains[0];
        }
        commit(DOMAINS_SELECT, selectedDomain);
    }
};

const mutations = {
    [DOMAINS_REQUEST]: (state) => {
        state.status = 'loading';
        Vue.set(state, 'domains', []);
        state.selectedDomain = null;
    },
    [DOMAINS_SUCCESS]: (state, resp) => {
        state.status = 'success';
        Vue.set(state, 'domains', resp);
    },
    [DOMAINS_ERROR]: (state) => {
        state.status = 'error'
    },
    [DOMAINS_SELECT]: (state, domain) => {
        state.selectedDomain = domain;
        if (domain) {
            localStorage.setItem('selected-domain-id', domain.id);
        }
    },
    [DOMAINS_CLEAR]: (state) => {
        state.status = '';
        Vue.set(state, 'domains', []);
        state.selectedDomain = null;
    }
};

export default {
    state,
    actions,
    mutations
}